import { createAppSlice } from 'app/createAppSlice'
import { getDataCommodities } from './configurationsListAction'

const initialState = {
  tag: {
    size: 10,
    page: 0,
  },
  details: null,
  commodities: [],
  loading: false,
}

export const configurationsListSlice = createAppSlice({
  name: 'configurationsList',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag.size = payload.size
      state.tag.page = payload.page
    }),
  }),
  extraReducers: (builder) => {
    builder.addCase(getDataCommodities.fulfilled, (state, { payload }) => {
      state.commodities = payload
      state.loading = false
    })
    builder.addCase(getDataCommodities.pending, (state, { payload }) => {
      state.loading = true
    })
    builder.addCase(getDataCommodities.rejected, (state, { payload }) => {
      state.loading = false
    })
  },
})

export const { setFetchOption } = configurationsListSlice.actions

export default configurationsListSlice.reducer
